module.exports = __webpack_public_path__ + "static/media/PoochIcon.c97e0fc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinPooch/PoochIcon.svg
// module id = 353
// module chunks = 0